import { Component, OnInit, Output, EventEmitter, Input, NgZone, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { PaginationInfo, ApiPagedResponse, ApiResponse } from 'app/client-core/api-response-models';
import { AppDatatableConfigOptions, AppBasicTableComponent } from 'app/shared/datatable';
import { FormControl } from '@angular/forms';

const $ = jQuery;

@Component({
  selector: 'app-cierant-typeahead',
  templateUrl: './cierant-typeahead.component.html',
  styleUrls: ['./cierant-typeahead.component.scss']
})
export class CierantTypeaheadComponent implements OnInit {
  @Input() items: Array<any> = [];
  @Output() itemEntered = new EventEmitter();
  typeaheadItem: string;
  showItems: boolean;
  @Input() selectableField = 'emailAddress';
  @Input() columns: Observable<Array<any>> = null;
  rows: Observable<Array<any>>;
  paginationInfo: Observable<any>;
  config: Observable<AppDatatableConfigOptions>;
  pageSize: number;
  pageSizeOptions: Array<number>;
  searchControl: FormControl;
  @Input() service: any;
  @Input() method: string;
  @Output() itemsChange = new EventEmitter();
  @Input() singleSelection: boolean;
  @Input() placeholder: string;
  @Output() rowSelected = new EventEmitter();
  @Input() disabled: boolean;
  @Input() extraQueryParams?: any;
  @ViewChild('basicTable') table: AppBasicTableComponent;
  @Input() name: string;

  public static clearTextEvent: Subject<string> = new Subject();

  constructor(
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    const self = this;
    CierantTypeaheadComponent.clearTextEvent.subscribe(name => {
      this.clearText();
    })
    $(document).click(function(event) {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
      if (!$(event.target).closest("app-cierant-typeahead,[name=uiKeyword],datatable-pager,datatable-footer,datatable-body,datatable-header,ngx-datatable,.pages>a").length) {
        console.log('teste');
        self.ngZone.run(() => {
          self.showItems = false;
        })
      }
    });
  }

  getItems(params, pageIndex?:number) {
    if (!this.service || !this.method) {
      return;
    }

    if (!params) {
      params = {};
    }

    if (this.typeaheadItem) {
      params['searchTerm'] = this.typeaheadItem;
    }

    if (pageIndex) {
      params['pageIndex'] = 0;
    }

    if (this.extraQueryParams) {
      params = {
        ...params,
        ...this.extraQueryParams
      }
    }

    params['pageSize'] = 5;

    const serviceCall = this.service[this.method](params) as Observable<ApiResponse<ApiPagedResponse<any>>>;
    serviceCall.subscribe(res => {
      if (!res.hasError) {
        if (res.data && res.data.items) {
          this.rows = Observable.of(res.data.items);
        } else {
          this.rows = Observable.of([]);
        }
        this.paginationInfo = Observable.of(res.data);
        if (res.data.pageIndex == 0) {
          $('.pager .pages').removeClass('active');
          $('.pager .pages').eq(0).addClass('active');
        }
      }
    })
  }

  addKeyword(item) {
    if (!item) {
      return;
    }
    if (this.items && !this.items.find(i => i === item)) {
      this.items.push(item);
    }
    this.itemsChange.emit(this.items);
  }

  removeKeyword(item) {
    this.items = this.items.filter(i => i !== item);
    this.itemsChange.emit(this.items);
  }

  selectRow(item) {
    console.log(item[this.selectableField]);
    this.typeaheadItem = item[this.selectableField];
    this.addKeyword(item[this.selectableField]);
  }

  hideITems() {
    setTimeout(() => {
      this.showItems = false;
    }, 400);
  }

  onRowSelect(event: any): void {
    console.log(">>> onRowSelect", event);
    if (event && event.selected && event.selected.length > 0) {
      const item = event.selected[0];
      this.rowSelected.emit(item);
      this.typeaheadItem = item[this.selectableField];
      this.addKeyword(item[this.selectableField]);
    }
    this.hideITems();
  }

  onRowActivate(event: any): void {
    //console.log(">> onRowActivate", event);
  }

  onTableAction(event: any): void {
    console.log(">>> onTableAction", event);
    this.getItems(event);
  }

  tableActionDone(event: any): void {
    console.log(">>> onTableActionDone", event);
    //this.submitting = false;
  }

  clearText() {
    this.typeaheadItem = "";
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/cierant-typeahead/cierant-typeahead.component.ts